import { ChartNoAxesColumnIncreasing } from 'lucide-preact';
import { ChartDropdown, StackedBarChart } from '../../components/charts';
import { ChartCard } from '../../components/ui';
import type { StackedBarData } from '../../components/charts/StackedBarChart';

interface UnitIncomeChartProps {
  unitCurrency: string;
  incomeYear: string;
  yearOptions: Array<{ id: string; label: string }>;
  stackedBarData: { xLabels: string[]; stacks: StackedBarData[] };
  loading: boolean;
  onYearChange: (id: string) => void;
}

export function UnitIncomeChart({
  unitCurrency,
  incomeYear,
  yearOptions,
  stackedBarData,
  loading,
  onYearChange,
}: UnitIncomeChartProps) {
  return (
    <ChartCard
      title="Income Statement Overview"
      icon={<ChartNoAxesColumnIncreasing size={16} strokeWidth={2} />}
      className="unit-income-card"
      controls={
        yearOptions.length > 0 ? (
          <ChartDropdown
            options={yearOptions}
            selectedId={incomeYear}
            onSelect={onYearChange}
          />
        ) : undefined
      }
    >
      <StackedBarChart
        className="unit-income-chart"
        xLabels={stackedBarData.xLabels}
        stacks={stackedBarData.stacks}
        title=""
        xAxisLabel=""
        yAxisLabel={unitCurrency}
        currencyCode={unitCurrency}
        loading={loading}
        height="100%"
      />
    </ChartCard>
  );
}
